import { fetcher } from '@common/utils/fetcher';

import { type User } from './UsersService';

export const SUPERLIKE_ERROR_CODES = {
  featureDisabled: 'feature_disabled',
  notDating: 'not_dating',
  notFound: 'not_found',
  alreadySuperliked: 'already_superliked',
  invalidMessage: 'invalid_message',
  superlikeLimit: 'superlike_limit',
  swipeLimit: 'swipe_limit',
  unavailable: 'unavailable',
  writeFailed: 'write_failed',
} as const;

export type SuperlikeSendStatus = 'sent' | 'held' | 'matched';

export type PostSuperlikeParams = {
  target_user_id: string;
  message?: string | null;
};

export type PostSuperlikeResponse = {
  status: SuperlikeSendStatus;
  remaining: number;
  reset_time: string;
};

export type GetSuperlikesStatusResponse = {
  limit: number;
  remaining: number;
  reset_time: string | null;
};

export type IncomingSuperlike = {
  message: string | null;
  created_at: string;
};

export type IncomingSuperlikeCard = User & {
  superlike: IncomingSuperlike;
};

export type GetSuperlikesIncomingParams = {
  limit?: number;
  cursor?: string;
};

export type GetSuperlikesIncomingResponse = {
  results: IncomingSuperlikeCard[];
  next_cursor: string | null;
};

export const postSuperlike = (data: PostSuperlikeParams) => {
  return fetcher<PostSuperlikeResponse>({
    url: '/superlikes',
    method: 'POST',
    data,
  });
};

export const getSuperlikesStatus = () => {
  return fetcher<GetSuperlikesStatusResponse>({
    url: '/superlikes/status',
    method: 'GET',
  });
};

export const getSuperlikesIncoming = (params?: GetSuperlikesIncomingParams) => {
  return fetcher<GetSuperlikesIncomingResponse>({
    url: '/superlikes/incoming',
    method: 'GET',
    params,
  });
};
